import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import GrainIcon from "@mui/icons-material/Grain";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import { useLocation, Link as RouterLink } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));

   const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <nav aria-label="breadcrumb">
      <Breadcrumbs separator="›" aria-label="breadcrumb">
         <Link
          component={RouterLink}
          underline="hover"
          color="inherit"
          to={userDetails?.user_category === "Finance" ? "/ayekart-fintech/finance-grids" : "/ayekart-fintech/orders"}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Home
        </Link>

        {/* Dynamic Breadcrumbs */}
        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;

          return isLast ? (
            <Typography
              key={to}
              color="text.primary"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <WhatshotIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </Typography>
          ) : (
            <Link
              component={RouterLink}
              underline="hover"
              color="inherit"
              // to={to}
              key={to}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <GrainIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </Link>
          );
        })}
      </Breadcrumbs>
    </nav>
  );
};

export default Breadcrumb;
